import {combineReducers} from 'redux';
import user from './user';
import common from './common';
import chat from './chat';
import websocket from './websocket';

const AppReducer = combineReducers({
  common,
  user,
  chat,
  websocket
});

export default AppReducer
